<template>
  <div id="WaitingPlayer">
    <div id="playerBox" class="player-box flex" :class="{free: !player, 'not-free': player}">
      <div id="name-box">
        <h3 class="name">{{ player ? player.name : 'LIBERO' }}</h3>
      </div>
      <div v-if="player">
        <img v-if="!player.is_bot" id="user-image" alt="user" :src="require('../assets/user.jpg')" width="100" height="100" />
        <img v-else id="user-image" alt="user" :src="require('../assets/bot.jpg')" width="100" height="100" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WaitingPlayer",
  components: {
  },
  props: {
    player: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters({ 
      user: "user/user"
    })
  },
};
</script>
<style scoped>
#playerBox {
  width: 224px;
  height: 60px;
  border-radius: 10px;
  padding: 10px 15px;
  margin: 1em;
}
.not-free {
  background-color:black;
  color: antiquewhite;
}
.free {
  background-color:antiquewhite;
  color: black;
}
#name-box {
  margin-right: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
#player-info{
  display: flex;
  flex-direction: column;
}
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.name {
  margin-left: 0.5em;
}
#user-image {
  width: 45px;
  height: 45px;
}

@media all and (max-width: 550px), (max-height: 400px) {
  #playerBox {
    width: 112px;
    height: 30px;
  }

  #user-image {
    width: 1px;
    height: 1px;
  }
  #name-box {
    position: fixed;
  }
  .name {
    font-size: 10px;
    width: 112px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
